import { Injectable, NgZone } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import * as theGlobals from 'src/app/shared/globals';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private numMinutes = theGlobals.inactivityMinutes;  // # of minutes of inactivity allowed prior to logoff
  private readonly inactivityTime = this.numMinutes * 60 * 1000;
  private inactivityTimer: any;

  constructor(private msalService: MsalService, private ngZone: NgZone) {
    this.setupInactivityTimer();
    this.listenToUserActivity();
  }

  private setupInactivityTimer() {
    this.ngZone.runOutsideAngular(() => {
      this.resetInactivityTimer();
    });
  }

  private resetInactivityTimer() {
    const now = new Date();
    // console.log('inactivity timer reset: ' + now);
    clearTimeout(this.inactivityTimer);
    this.ngZone.runOutsideAngular(() => {
      this.inactivityTimer = setTimeout(() => {
        this.ngZone.run(() => this.logout());
      }, this.inactivityTime);
    });
  }

  private listenToUserActivity() {
    document.addEventListener('mousemove', () => this.resetInactivityTimer());
    document.addEventListener('keydown', () => this.resetInactivityTimer());
    document.addEventListener('click', () => this.resetInactivityTimer());
  }

  private logout() {
    alert('Your session has timed out. Logging off...')
    this.msalService.logoutRedirect(); // Logs out the user and redirects to the AAD logout page
  }
}
